import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  class: "card card-stretch shadow",
  style: {"margin-bottom":"10px"}
}
const _hoisted_2 = {
  class: "card-body",
  style: {"padding":"15px"}
}
const _hoisted_3 = /*#__PURE__*/_createTextVNode("Эхлэл")
const _hoisted_4 = /*#__PURE__*/_createTextVNode("Тайлан")
const _hoisted_5 = /*#__PURE__*/_createTextVNode("Хянан шалгагч")
const _hoisted_6 = {
  key: 0,
  class: "row g-5"
}
const _hoisted_7 = { class: "col-lg-12" }
const _hoisted_8 = { class: "card shadow" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", { class: "card-header" }, [
  /*#__PURE__*/_createElementVNode("h3", { class: "card-title" }, [
    /*#__PURE__*/_createElementVNode("i", { class: "el-icon-notebook-2 fs-2 text-dark" }),
    /*#__PURE__*/_createTextVNode(" "),
    /*#__PURE__*/_createElementVNode("b", null, "Тайлан гаргах")
  ])
], -1)
const _hoisted_10 = { class: "card-body" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("p", { style: {"line-height":"2.0","margin-bottom":"0","font-weight":"600"} }, " Нийт үлдэгдэлтэй зээлийн тоо /байгууллагаар/ ", -1)
const _hoisted_12 = ["data-kt-indicator"]
const _hoisted_13 = /*#__PURE__*/_createElementVNode("span", { class: "indicator-label" }, [
  /*#__PURE__*/_createTextVNode(" Татах  "),
  /*#__PURE__*/_createElementVNode("i", { class: "fas fa-download text-success" })
], -1)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("span", { class: "indicator-progress" }, [
  /*#__PURE__*/_createTextVNode(" Түр хүлээнэ үү... "),
  /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" })
], -1)
const _hoisted_15 = [
  _hoisted_13,
  _hoisted_14
]
const _hoisted_16 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_17 = /*#__PURE__*/_createElementVNode("p", { style: {"line-height":"2.0","margin-bottom":"0","font-weight":"600","word-break":"break-all","white-space":"normal"} }, " Зээлийн мэдээллийн жагсаалт /үлдэгдэлтэй/ ", -1)
const _hoisted_18 = ["data-kt-indicator"]
const _hoisted_19 = /*#__PURE__*/_createElementVNode("span", { class: "indicator-label" }, [
  /*#__PURE__*/_createTextVNode(" Татах  "),
  /*#__PURE__*/_createElementVNode("i", { class: "fas fa-download text-success" })
], -1)
const _hoisted_20 = /*#__PURE__*/_createElementVNode("span", { class: "indicator-progress" }, [
  /*#__PURE__*/_createTextVNode(" Түр хүлээнэ үү... "),
  /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" })
], -1)
const _hoisted_21 = [
  _hoisted_19,
  _hoisted_20
]
const _hoisted_22 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_23 = /*#__PURE__*/_createElementVNode("p", { style: {"line-height":"2.0","margin-bottom":"0","font-weight":"600"} }, " Лавлагаа /2021 оны 06 сарын 30 байдлаар/ ", -1)
const _hoisted_24 = ["data-kt-indicator"]
const _hoisted_25 = /*#__PURE__*/_createElementVNode("span", { class: "indicator-label" }, [
  /*#__PURE__*/_createTextVNode(" Татах  "),
  /*#__PURE__*/_createElementVNode("i", { class: "fas fa-download text-success" })
], -1)
const _hoisted_26 = /*#__PURE__*/_createElementVNode("span", { class: "indicator-progress" }, [
  /*#__PURE__*/_createTextVNode(" Түр хүлээнэ үү... "),
  /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" })
], -1)
const _hoisted_27 = [
  _hoisted_25,
  _hoisted_26
]
const _hoisted_28 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_29 = /*#__PURE__*/_createElementVNode("p", { style: {"line-height":"2.0","margin-bottom":"0","font-weight":"600","word-break":"break-all","white-space":"normal"} }, " Зээлийн мэдээллийн лавлагааны шимтгэл төлөлт /хэрэглэгч байгууллагаар/ ", -1)
const _hoisted_30 = { style: {"float":"left"} }
const _hoisted_31 = { style: {"float":"right","color":"#8492a6","font-size":"13px"} }
const _hoisted_32 = ["data-kt-indicator"]
const _hoisted_33 = /*#__PURE__*/_createElementVNode("span", { class: "indicator-label" }, [
  /*#__PURE__*/_createTextVNode(" Татах  "),
  /*#__PURE__*/_createElementVNode("i", { class: "fas fa-download text-success" })
], -1)
const _hoisted_34 = /*#__PURE__*/_createElementVNode("span", { class: "indicator-progress" }, [
  /*#__PURE__*/_createTextVNode(" Түр хүлээнэ үү... "),
  /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" })
], -1)
const _hoisted_35 = [
  _hoisted_33,
  _hoisted_34
]
const _hoisted_36 = /*#__PURE__*/_createElementVNode("br", null, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_breadcrumb_item = _resolveComponent("el-breadcrumb-item")!
  const _component_el_breadcrumb = _resolveComponent("el-breadcrumb")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_space = _resolveComponent("el-space")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_el_breadcrumb, { "separator-class": "el-icon-arrow-right" }, {
          default: _withCtx(() => [
            _createVNode(_component_el_breadcrumb_item, { to: { path: '/' } }, {
              default: _withCtx(() => [
                _hoisted_3
              ]),
              _: 1
            }),
            _createVNode(_component_el_breadcrumb_item, null, {
              default: _withCtx(() => [
                _hoisted_4
              ]),
              _: 1
            }),
            _createVNode(_component_el_breadcrumb_item, null, {
              default: _withCtx(() => [
                _hoisted_5
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ])
    ]),
    (this.isu)
      ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              _hoisted_9,
              _createElementVNode("div", _hoisted_10, [
                _createVNode(_component_el_row, {
                  size: "mini",
                  type: "flex",
                  justify: "space-between"
                }, {
                  default: _withCtx(() => [
                    _hoisted_11,
                    _createElementVNode("button", {
                      class: "el-button el-button--success el-button--mini is-plain",
                      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.getReportTotalLoans && _ctx.getReportTotalLoans(...args))),
                      "data-kt-indicator": this.loadButton
                    }, _hoisted_15, 8, _hoisted_12)
                  ]),
                  _: 1
                }),
                _hoisted_16,
                _createVNode(_component_el_row, {
                  size: "mini",
                  type: "flex",
                  justify: "space-between"
                }, {
                  default: _withCtx(() => [
                    _hoisted_17,
                    _createElementVNode("div", null, [
                      _createVNode(_component_el_space, { size: "small" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_select, {
                            modelValue: this.yearValue,
                            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((this.yearValue) = $event)),
                            "collapse-tags": "",
                            size: "mini",
                            placeholder: "-- Он сонгох --"
                          }, {
                            default: _withCtx(() => [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(this.years, (item) => {
                                return (_openBlock(), _createBlock(_component_el_option, {
                                  key: item.yearValue,
                                  label: item.yearLabel,
                                  value: item.yearValue
                                }, null, 8, ["label", "value"]))
                              }), 128))
                            ]),
                            _: 1
                          }, 8, ["modelValue"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_select, {
                        modelValue: this.monthValue,
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((this.monthValue) = $event)),
                        "collapse-tags": "",
                        size: "mini",
                        placeholder: "-- Сар сонгох --"
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.months, (item) => {
                            return (_openBlock(), _createBlock(_component_el_option, {
                              key: item.monthValue,
                              label: item.monthLabel,
                              value: item.monthValue
                            }, null, 8, ["label", "value"]))
                          }), 128))
                        ]),
                        _: 1
                      }, 8, ["modelValue"])
                    ]),
                    _createElementVNode("button", {
                      class: "el-button el-button--success el-button--mini is-plain",
                      onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.getReportInvoiceReport && _ctx.getReportInvoiceReport(...args))),
                      "data-kt-indicator": this.loadButton
                    }, _hoisted_21, 8, _hoisted_18)
                  ]),
                  _: 1
                }),
                _hoisted_22,
                _createVNode(_component_el_row, {
                  size: "mini",
                  type: "flex",
                  justify: "space-between"
                }, {
                  default: _withCtx(() => [
                    _hoisted_23,
                    _createVNode(_component_el_input, {
                      class: "col-md-2",
                      modelValue: this.registerno,
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((this.registerno) = $event)),
                      size: "mini",
                      placeholder: "Регистрийн дугаар"
                    }, null, 8, ["modelValue"]),
                    _createElementVNode("button", {
                      class: "el-button el-button--success el-button--mini is-plain",
                      onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.getReportReportInquiry && _ctx.getReportReportInquiry(...args))),
                      "data-kt-indicator": this.loadButton
                    }, _hoisted_27, 8, _hoisted_24)
                  ]),
                  _: 1
                }),
                _hoisted_28,
                _createVNode(_component_el_row, {
                  size: "mini",
                  type: "flex",
                  justify: "space-between"
                }, {
                  default: _withCtx(() => [
                    _hoisted_29,
                    _createElementVNode("div", null, [
                      _createVNode(_component_el_space, { size: "small" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_select, {
                            modelValue: this.orgValue,
                            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((this.orgValue) = $event)),
                            "collapse-tags": "",
                            filterable: "",
                            size: "mini",
                            placeholder: "-- Байгууллага сонгох --"
                          }, {
                            default: _withCtx(() => [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(this.orgList, (item) => {
                                return (_openBlock(), _createBlock(_component_el_option, {
                                  key: item.orgcode,
                                  label: item.orgname,
                                  value: item.orgcode
                                }, {
                                  default: _withCtx(() => [
                                    _createElementVNode("span", _hoisted_30, _toDisplayString(item.orgname), 1),
                                    _createElementVNode("span", _hoisted_31, _toDisplayString(item.orgcode), 1)
                                  ]),
                                  _: 2
                                }, 1032, ["label", "value"]))
                              }), 128))
                            ]),
                            _: 1
                          }, 8, ["modelValue"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_space, { size: "small" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_date_picker, {
                            size: "mini",
                            type: "date",
                            modelValue: this.dateOfStart,
                            "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((this.dateOfStart) = $event)),
                            placeholder: "YYYY-MM-DD"
                          }, null, 8, ["modelValue"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_space, { size: "small" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_date_picker, {
                            size: "mini",
                            type: "date",
                            modelValue: this.dateOfEnd,
                            "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((this.dateOfEnd) = $event)),
                            placeholder: "YYYY-MM-DD"
                          }, null, 8, ["modelValue"])
                        ]),
                        _: 1
                      })
                    ]),
                    _createElementVNode("button", {
                      class: "el-button el-button--success el-button--mini is-plain",
                      onClick: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.getReportInvoicePayment && _ctx.getReportInvoicePayment(...args))),
                      "data-kt-indicator": this.loadButton
                    }, _hoisted_35, 8, _hoisted_32)
                  ]),
                  _: 1
                }),
                _hoisted_36,
                _createVNode(_component_el_row, null, {
                  default: _withCtx(() => [
                    _withDirectives((_openBlock(), _createBlock(_component_el_table, {
                      data: this.reportLog,
                      "element-loading-text": "Өгөгдөл татаж байна...",
                      "empty-text": "Өгөгдөл байхгүй байна.",
                      size: "mini",
                      "max-height": "300",
                      border: "",
                      "cell-style": { textAlign: 'center' },
                      "header-cell-style": { textAlign: 'center' }
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_table_column, {
                          label: "№",
                          width: "40"
                        }, {
                          default: _withCtx((scope) => [
                            _createTextVNode(_toDisplayString(scope.$index + 1), 1)
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_table_column, {
                          label: "Тайлангийн нэр",
                          prop: "reportname",
                          sortable: ""
                        }),
                        _createVNode(_component_el_table_column, {
                          label: "Тайлангийн параметер",
                          prop: "params",
                          sortable: ""
                        }),
                        _createVNode(_component_el_table_column, {
                          label: "Байгууллагын код",
                          prop: "orgcode",
                          sortable: ""
                        }),
                        _createVNode(_component_el_table_column, {
                          label: "Тайлан гаргасан",
                          prop: "userid",
                          sortable: ""
                        }),
                        _createVNode(_component_el_table_column, {
                          label: "Татсан огноо",
                          prop: "actiondate",
                          formatter: _ctx.$filters.formatDateYMDHMS,
                          sortable: ""
                        }, null, 8, ["formatter"]),
                        _createVNode(_component_el_table_column, {
                          label: "Файлын хэмжээ",
                          prop: "filesize",
                          sortable: ""
                        })
                      ]),
                      _: 1
                    }, 8, ["data"])), [
                      [_directive_loading, this.reportLogLoading]
                    ])
                  ]),
                  _: 1
                })
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ], 64))
}